// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"790995c9","183":"afad4270","344":"7d7a478b"}[chunkId] + ".chunk.js";
};